<template>
  <div
    v-if="prosProductPoolMedia"
    :class="['pros-product-pool-cont', classAttributes]"
  >
    <ProsCollection
      :panel-config="panelConfig"
      :recommendation-config="recommendationConfig"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ProsCollection } from '@common-vue/pros-collection';
import { brand } from 'config';
import { getClassAttributes } from '../../helpers/getAttributes';

const props = defineProps({
  prosProductPoolMedia: {
    type: Object,
    default: () => ({}),
  },
  properties: {
    type: Object,
    default: () => ({}),
  },
});

const zone = computed(() => props.prosProductPoolMedia?.context);

// ProsProductPool includes zone name
const recommendationConfig = {
  categoryId: props.prosProductPoolMedia?.categoryId,
  productId: props.prosProductPoolMedia?.productId,
  productIds: props.prosProductPoolMedia?.productIds,
  zone: zone.value,
  maxRecommendations: props.prosProductPoolMedia?.maxRecs,
  imageId: props.prosProductPoolMedia?.imageId,
};

const panelConfig = {
  properties: props.properties?.properties,
  title: props.prosProductPoolMedia?.header,
  linkUrl: props.prosProductPoolMedia?.url,
  linkName: props.prosProductPoolMedia?.attributes?.HEADER_LINK_TEXT,
  componentType: props.prosProductPoolMedia?.componentType,
  panelType: props.prosProductPoolMedia?.panelType,
  numberOfItems: zone.value === 'HP_ZONE_D' || zone.value === 'C2FLEX_ZONE_C' ? {
    small: 2.45,
    medium: { row: 2, column: 4 },
    large: { row: 2, column: 3 },
  } : {
    small: 2.45,
    medium: 5.3,
    large: brand === 'bcom' ? 6 : 5.2,
  },
};

const classAttributes = getClassAttributes(props.prosProductPoolMedia?.attributes);
const bgColor = props.prosProductPoolMedia?.attributes?.bgColor || 'initial';
const rightTitleIndent = props.productPoolMedia?.attributes?.fullWidth === 'true' ? '20px' : '0';
</script>

<style lang="scss" scoped>
.pros-product-pool-cont :deep(.title-container) {
  @include breakpoint(medium down) {
    padding-right: v-bind(rightTitleIndent);
  }
}
</style>

<style lang="scss" brand="mcom" scoped>
@import "./../../scss/globalAttributes.mcom.scss";
</style>

<style src="@csgIcons/_review-star-filled-small.scss" lang="scss" brand="mcom"></style>

<style lang="scss" brand="bcom" scoped>
@import "./../../scss/globalAttributes.bcom.scss";

.pros-product-pool-cont {
  background-color: v-bind(bgColor);

  :deep(.product-pool-media-container .poolHeader) {
    background-color: v-bind(bgColor);
  }
  :deep(.wish-list-removed){
    display:none;
  }
}
</style>
